// @ts-nocheck

class MMCartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }
  
    init() {
      this.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });
  
      this.addEventListener('click', (evt) => {
        if (evt.target.id === 'CartDrawer-Overlay') {
          this.close();
        }
      });
  
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');
      if (!cartLinks.length) return;

      cartLinks.forEach((cartLink) => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          const isCartPage = window.location.pathname.includes('/cart');
          if (isCartPage) return;

          event.preventDefault();
          this.show(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.show(cartLink);
          }
        });
      });
    }
  
    show(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
  
      setTimeout(() => {
        this.classList.add('active');
      });
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  
  }
  
  customElements.define('mm-cart-drawer', MMCartDrawer);
  